
const defaultState = {
    pagetype: '',
    path: '',
    topText: '',
    bottomText: '',
    title: '',
    count_heading: '',
    show_title: true,
    show_description: true,
    html_title: '',
    meta_description: '',
    sysKeyValue: [],
    breadCrumbs: [],
    staticIndustries: [],
    locationSyskeyValue: [],
};
import axios from 'axios';

const mutations = {
    setState(state, newState) {
        Object.assign(state, newState);
    },
    resetState(state) {
        Object.assign(state, defaultState);
    },
    setPageType(state, value) {
        state.pagetype = value;
    },
    setLocationSyskeyValue(state, value) {
        state.locationSyskeyValue = value;
    },
}

const getters = {
    isIndustryTown( state, getters ) {
        return getters.getPageType == 'industrytown';
    },
    isRegion( state, getters ) {
        return getters.getPageType == 'region';
    },
    isCounty( state, getters ) {
        return getters.getPageType == 'county';
    },
    isTown( state, getters ) {
        return getters.getPageType == 'town';
    },
    isIndustryCounty( state, getters ) {
        return getters.getPageType == 'industrycounty';
    },
    isPersonalPage( state, getters ) {
        return getters.getPageType == 'personalpage';
    },
    hasCountHeading( state ) {
        return state.count_heading != '';
    },
    getPageType( state ) {
        return state.pagetype.toLowerCase();
    },
    hasPageText( state ) {
        return state.topText != '' || state.bottomText != '';
    },
    isLocationPage( state, getters ) {
        return getters.isIndustryCounty || getters.isIndustryTown 
            || getters.isRegion || getters.isCounty || getters.isTown;
    },
    getLocationSyskey(state) {
        // this should have been an axios call so it didn't get cached
        return state.locationSyskeyValue
    },
}

const actions = {
    updateState({ state, commit }, newState) {
        commit('setState', newState);
        document.title = state.html_title;
        let el = document.querySelector("head meta[name='description']");
        el.setAttribute('content', state.meta_description);
    },
    async fetchLocationSyskey({ commit }) {
        try {
            const response = await axios.get('/api/locationSyskey');
            commit('setLocationSyskeyValue', response.data.locationSyskeyValue);
        } catch (error) {
            console.error('Failed to fetch locationSyskeyValue:', error);
        }
    },
}

export default {
    namespaced: true,
    state: defaultState,
    mutations,
    getters,
    actions
};
